import { render, staticRenderFns } from "./SalaryEffectTypeCreateOrUpdate.vue?vue&type=template&id=5008ec03&"
import script from "./SalaryEffectTypeCreateOrUpdate.vue?vue&type=script&lang=js&"
export * from "./SalaryEffectTypeCreateOrUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports